export default __webpack_public_path__ + "static/media/start-2022.10ab007c.gif";